var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5V12.5C20 7.52944 16.4183 3.5 12 3.5C7.58172 3.5 4 7.52944 4 12.5V16.5",
    stroke: "white",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40117 16.5C8.40117 17.4482 8.11191 18.2759 7.68249 18.8484C7.25325 19.4207 6.72134 19.7 6.20117 19.7C5.68101 19.7 5.14909 19.4207 4.71985 18.8484C4.29043 18.2759 4.00117 17.4482 4.00117 16.5C4.00117 15.5518 4.29043 14.7241 4.71985 14.1516C5.14909 13.5793 5.68101 13.3 6.20117 13.3C6.72134 13.3 7.25325 13.5793 7.68249 14.1516C8.11191 14.7241 8.40117 15.5518 8.40117 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9988 16.5C19.9988 17.4482 19.7096 18.2759 19.2801 18.8484C18.8509 19.4207 18.319 19.7 17.7988 19.7C17.2787 19.7 16.7467 19.4207 16.3175 18.8484C15.8881 18.2759 15.5988 17.4482 15.5988 16.5C15.5988 15.5518 15.8881 14.7241 16.3175 14.1516C16.7467 13.5793 17.2787 13.3 17.7988 13.3C18.319 13.3 18.8509 13.5793 19.2801 14.1516C19.7096 14.7241 19.9988 15.5518 19.9988 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b0a97a5ca57e5c34649a9e92d554d17b.svg";
export { ForwardRef as ReactComponent };